// First Main Coin Inflow - English
export default {
  title: "First Main Coin Inflow",
  loading: { text: "Loading..." },
  fields: {
    address: "Address",
    txHash: "Tx Hash",
    quantity: "Quantity",
    txTime: "Time",
  },
  copy: "Copy",
  none: "--",
};
